import { truncateString } from '@/utils/utils';

export class ContentSerializer {

    private static INSTANCE = new ContentSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    public normalizeTranscript(payload: any) {
        let transcripts = payload.transcripts ? payload.transcripts : [];
        if (transcripts) {
            transcripts = transcripts.map((transcript: any) => {
                transcript.shortTranscript = truncateString(transcript.transcript, 35);
                return transcript;
            });
        }
        return transcripts;
    }

    public normalizeSummary(payload: any) {
        let summaries = payload.summary ? payload.summary : [];
        if (summaries) {
            summaries = summaries.map((summary: any) => {
                summary.shortSummary = summary.summaryText[0]
                    ? truncateString(summary.summaryText[0], 35)
                    : '';
                return summary;
            });
        }
        return summaries;
    }

    public normalizeSummaryAndTranscript(payload: any) {
        if (!payload || !Array.isArray(payload)) {
            return [];
        }
        return payload.filter((item) => item).map((item: any) => ({
            resource_id: item.resource_id,
            summary: {
                long_text : item.summary,
                shortSummary: item.summary ? truncateString(item.summary, 35) : '',
            },
            transcript: {
                long_text: item.transcript_text,
                shortTranscript: item.transcript_text ? truncateString(item.transcript_text, 35) : '',
            },
            transcript_id: item.transcript_id,
            phrasecloud: item.phrasecloud || null,
            ageRange: item.ageRange || null,
            DepthOfKnowledge: item.DepthOfKnowledge || null,
            readinglevel: item.readinglevel || null,
            centurySkills: item.centurySkills || null,
            accessbility: item.accessbility || null,
            mediaFeatures: item.mediaFeatures || null,
        }));
    }
}

export const contentSerializer = ContentSerializer.instance;
